import { useEffect, useState } from "react";
import React from 'react';
import { getCircular } from "../Service/Api";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";

const AwardsAcheivements = () => {
    const [data, setData] = useState([]);
    const [index, setIndex] = React.useState(-1);

    useEffect(() => {
        const fetchData = async () => {
            const galleryData1 = await getCircular();
    
            // Step 1: Filter only 'Achievements'
            const filteredData = galleryData1.filter(item => item.category === 'Achievements');
    
            // Step 2: Group by year
            const groupedByYear = filteredData.reduce((acc, item) => {
                const year = new Date(item.date).getFullYear();
                if (!acc[year]) {
                    acc[year] = [];
                }
                acc[year].push(item);
                return acc;
            }, {});
    
            // Step 3: Sort years descending
            const sortedYears = Object.keys(groupedByYear).sort((a, b) => b - a);
    
            // Step 4: Sort each year's data by date descending
            const finalData = sortedYears.map(year => ({
                year,
                items: groupedByYear[year].sort((a, b) => new Date(b.date) - new Date(a.date))
            }));
    
            setData(finalData);
        };
    
        fetchData();
    }, []);
    
    
    

    const homeMenu = [
        { label: "Vision", link: "/about" },
        { label: "Management", link: "", subMenu: [
                { label: "Director-Principal's Message", link: "/PrincipalMessage" },
                { label: "Leadership Team", link: "/leadershipTeam" },
                { label: "Patron’s Message", link: "/patrons" },
                { label: "Advisory Board", link: "/advisoryBoard" },
            ]
        },
        { label: "International Collaborations", link: "/partnership" },
        { label: "Awards & Achievements", link: "/awardsAcheivements" },
        { label: "Faculty", link: "/faculty" },
        { label: "Staff Details", link: "/staffDetails" },
        { label: "School Strength ", link: "/schoolStrength" },
        { label: "Gallery", link: "/Gallery", subMenu: [{ label: "Photo Gallery", link: "/Gallery" }, { label: "Video Gallery", link: "/VideoGallery" },] },
    ];

    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-awards.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Awards & Achievements" breadEnd="Awards & Achievements" breadMid="Awards & Achievements" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="awards-box">
                            {data.length > 0 && (
                                data.map((group, groupIndex) => (
                                    <div key={groupIndex}>
                                        <h2 className="year-heading" style={{display:'none'}}>{group.year}</h2>
                                        {group.items.map((item, index) => (
                                            <div className="section-box" key={index}>
                                                <a 
                                                    data-magnify="gallery" 
                                                    data-src="" 
                                                    data-group="a" 
                                                    href={`https://webapi.entab.info/api/image/${item?.images[0]}`} 
                                                    onClick={() => setIndex(index)}
                                                >  
                                                    <LazyLoad>
                                                        <img
                                                            src={`https://webapi.entab.info/api/image/${item?.images[0]}`}  
                                                            alt={item?.title || "Lotus Valley School, Gurgaon"}
                                                            className="img-fluid"
                                                        />
                                                    </LazyLoad>
                                                </a>  
                                                <div className="para-box">
                                                    <h5 className="color-red">
                                                        <i className="bi bi-trophy-fill"></i> {item.title}
                                                    </h5>
                                                    
                                                    <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))
                            )}
                            
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default AwardsAcheivements;
